import { Link } from "react-router-dom";

export function Logo({ className = "", height = "h-9" }) {
  return (
    <Link to="/" className={`logo-wrap inline-flex items-center ${className}`} data-testid="logo-home-link">
      <img src="/logo.png?v=3" alt="Garage Ter Spelt" className={`${height} w-auto object-contain select-none`} draggable={false} />
    </Link>
  );
}
